import $ from 'jquery'

const initializeBlock = function ($block) {
  const el = $block.find('.team-block__scroll')
  const target = $block.find('.team-block__members')

  el.on('click', function () {
    target[0].scrollIntoView({ behavior: 'smooth' })
  })
}

$('.team-block').each(function () {
  initializeBlock($(this))
})

if (window.acf) {
  window.acf.addAction('render_block_preview/type=nrj-team', initializeBlock)
}
